module.exports = ".cnt-register {\n  padding: 2em 0 3em 0; }\n"